import React, {useState, useEffect} from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { IOID4VCIClientCreateOfferUriResponse } from "@sphereon/ssi-sdk.oid4vci-issuer-rest-client";
import { QRRenderingProps, QRType } from "@sphereon/ssi-sdk.qr-code-generator";
import { IssueStatus, IssueStatusResponse } from "@sphereon/oid4vci-common";
import agent from "../../../../../agent";
const short = require("short-uuid");

interface BookingConfirmationProps{
  fullName: string;
}

const BookingConfirmation = (props: BookingConfirmationProps) => {
  const [showBookingDetails, setShowBookingDetails] = useState(false);
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [bookingIssued, setBookingIssued] = useState(false);
  const [bookingId, setBookingId] = useState("");
  const [lastName, setLastName] = useState("");
  const [qrData, setQrData] = useState<any>();
  const [uri, setUri] = useState("");
  const [preAuthCode, setPreAuthCode] = useState("");
  const [qrCode, setQrCode] = useState<JSX.Element>();

  useEffect(() => {
    // generateNewQRCodeForInsurance();
  }, []);

  const renderingProps: QRRenderingProps = {
    bgColor: "#FBFBFB",
    fgColor: "black",
    level: "L",
    size: 330,
  };

  const handleButtonClick = () => {
    setShowBookingForm(true);
  };

  const handleFormSubmit = () => {
    setShowBookingForm(false);
    setShowBookingDetails(true);
  };

  // const generateNewQRCodeForInsurance = async () => {
  //   const shortUuid = short.generate();
  //   let today = new Date();

  //   const uriData: IOID4VCIClientCreateOfferUriResponse =
  //     await agent.oid4vciClientCreateOfferUri({
  //       grants: {
  //         "urn:ietf:params:oauth:grant-type:pre-authorized_code": {
  //           "pre-authorized_code": shortUuid,
  //           user_pin_required: false,
  //         },
  //       },
  //       credentialDataSupplierInput: {
  //         bookingId: "123456789",
  //         fullName: props.fullName,
  //         sendCompanyInvoice: "true",
  //         companyName: "Netcetera AG",
  //         hotelName: "Luxury Hotel",
  //         hotelAddress: "Paradise Street 7, 8606 Shangri La, Utopia",
  //         checkInDate: new Date().setDate(today.getDate() + 7),
  //         checkOutDate: new Date().setDate(today.getDate() + 14),
  //         roomType: "Junior Suite",
  //         additionalServices: "breakfast included, SPA Access included"
  //       },
  //       credentials: ["BookingCredential"],
  //     });



  //   const qrState = {
  //     uri: uriData.uri,
  //     preAuthCode: shortUuid,
  //     qrData: {
  //       object: uriData.uri,
  //       type: QRType.URI,
  //       id: "567",
  //     },
  //   };
  //   setUri(uriData.uri);
  //   setPreAuthCode(shortUuid);
  //   let dataQR: any= {
  //     object: uriData.uri,
  //     type: QRType.URI,
  //     id: "567",
  //   };
  //   setQrData(dataQR);

  //   agent
  //     .qrURIElement({
  //       data: dataQR,
  //       renderingProps: renderingProps,
  //     })
  //     .then((qrCode: JSX.Element) => {
  //       setQrCode(qrCode);
  //     });

  //   const intervalId = setInterval(() => {
  //     agent
  //       .oid4vciClientGetIssueStatus({ id: shortUuid! })
  //       .then((status: IssueStatusResponse) => {
  //         if (status.status === IssueStatus.CREDENTIAL_ISSUED) {
  //           clearInterval(intervalId);
  //           setQrCode(undefined);
  //           setBookingIssued(true);
  //         } else if (status.status === IssueStatus.ERROR) {
  //           // TODO: Add feedback to user
  //           console.error(status.error);
  //           clearInterval(intervalId);
  //         }
  //       })
  //       .catch((error: Error) => {
  //         clearInterval(intervalId);
  //         console.error(`ERROR: ${error.message}`);
  //       });
  //   }, 1000);
  // }
  return (
    <Container style={{ textAlign: "center", padding: "50px" }}>
      { true?  (
              <Row className="my-5" style={{ height: "100%" }}>
              <Col md={6} className="d-flex align-items-center">
                <div>
                  <h2>Booking Confirmation</h2>
                  <p>
                   Enjoy your stay and we hope you had a great experience!!
                  </p>
                </div>
              </Col>
              <Col
                md={6}
                className="text-center d-flex flex-column justify-content-center align-items-center"
              >
                <div>
                <div>{qrCode}</div>
                </div>
              </Col>
            </Row>
            ) : (
              <Row className="my-5" style={{ height: "100%" }}>
              <Col md={12} className="align-items-center">
                <div>
                  <h2>Thank you for your trust!</h2>
                  <p>
                   Enjoy your stay and we hope you had a great experience!!
                  </p>
                </div>
              </Col>
            </Row>
            )}
    </Container>
  );
};

export default BookingConfirmation;
